import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from 'redux';
import { AppThunk } from 'store';

import { ICommunicationNotifications } from '../../entities/communication.notification.entity';
import { NotificationsApi } from '../api/notification.api';
import {
  fetchNotificationFailed,
  fetchNotifications,
  fetchNotificationSucceeded,
} from '../slice/notifications.slice';

export const updateNotificationRequest = (
  id: string,
  values: Partial<ICommunicationNotifications>,
  onError: (err?: AxiosError) => void,
): AppThunk<Promise<any>> => async (dispatch: Dispatch<any>) => {
  let response: AxiosResponse = null;
  dispatch(fetchNotifications({ key: id }));
  try {
    response = await NotificationsApi.updateNotification(id, values);

    dispatch(
      fetchNotificationSucceeded({
        data: { [id]: response.data },
        key: id,
      }),
    );
    onError();
  } catch (err) {
    const { name, response: responseError, stack, isAxiosError } = err;

    const error = {
      isAxiosError,
      message: responseError?.data?.message,
      name,
      code: responseError?.data?.statusCode,
      stack,
      config: {},
      toJSON: null,
    };
    // - Fetch failed, set error
    dispatch(
      fetchNotificationFailed({
        key: id,
        error,
      }),
    );
    onError(error);
    throw error;
  }
};
